import { UPDATE_AUDIT_TEMPLATE, LOAD_AUDIT_TEMPLATE } from "../types";

const initialState = {
    template: {},
};

export const auditTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_AUDIT_TEMPLATE:
            return {
                ...state,
                template: action.payload ?? {
                    bookId: null,
                    isActive: false,
                    header: "",
                    footer: "",
                    title: "",
                    subtitle: "",
                    logoUrl: null,
                    lastUpdated: null,
                },
            };
        case UPDATE_AUDIT_TEMPLATE:
            return {
                ...state,
                template: action.payload,
            };
        default:
            return state;
    }
};